var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod-home"},[_c(_vm.currentHome,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }